<template>
  <div class="body">
    <el-card class="box_card">
      <div class="card-content">
        <div class="header">
          <div @click="goBackList()" class="flex flex-middle header-l">
            <i class="iconfont icontuichu"></i>
            <span class="bold">返回患者主页</span>
          </div>
        </div>

        <div class="main-content">
          <div class="titles flex flex-middle flex-center bold">糖尿病中级风险</div>
          <div class="descs">
            糖尿病是一组以高血糖为特征的代谢性疾病。高血糖则是由于胰岛素分泌缺陷或其生物作用受损，或两者兼有引起。长期存在的高血糖，导致各种组织，特别是眼、肾、心脏、血管、神经的慢性损害、功能障碍。
          </div>

          <!-- 表格 -->
          <div class="main-table flex flex-middle">
            <div class="item1">项目</div>
            <div class="item2">原因</div>
            <div class="item3">价格</div>
          </div>
          <div class="patient_box">
            <div class="patient_box_item flex flex-middle" v-for="(item, index) in 10" :key="index + 'yyy'">
              <div class="item1_content">糖化血红蛋白</div>
              <div class="item2_content">
                是葡萄糖与血红蛋白非酶促反应结合的产物，反应不可逆，HbA1c水平稳定，可反映取血前3个月的平均血糖水平。是判断血糖控制状态最有价值的指标。是葡萄糖与血红蛋白非酶促反应结合的产物，反应不可逆，HbA1c水平稳定，可反映取血前3个月的平均血糖水平。是判断血糖控制状态最有价值的指标。是葡萄糖与血红蛋白非酶促反应结合的产物，反应不可逆，HbA1c水平稳定，可反映取血前3个月的平均血糖水平。是判断血糖控制状态最有价值的指标。
              </div>
              <div class="item3_content">￥45.00</div>
            </div>
          </div>
        </div>

        <div class="flex flex-center flex-middle meal-box">
          <span class="title">糖尿病中级风险推荐超值套餐：</span>
          <span class="price">￥359.00</span>
        </div>
        <div class="flex flex-center openBtn">
          <el-button type="primary" round>一键开单</el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'Query',
  data() {
    return {
      customerId: '',
      list: ['1', '2', '3'],
      options: [
        {
          value: '选项1',
          label: '黄金糕'
        },
        {
          value: '选项2',
          label: '双皮奶'
        },
        {
          value: '选项3',
          label: '蚵仔煎'
        },
        {
          value: '选项4',
          label: '龙须面'
        },
        {
          value: '选项5',
          label: '北京烤鸭'
        }
      ],
      value: ''
    };
  },
  created() {
    this.customerId = this.$route.query.customerId;
  },
  mounted() {
    var that = this;
  },
  methods: {
    //打开患者档案

    goBackList() {
      let that = this;
      that.$router.push({ path: '/patientFiles', query: { customerId: that.customerId } });
    }
    // goDiseaseRisk() {
    //   let vm = this;
    //   vm.$router.push({ path: '/patient', query: { name: '22222' } });
    // }
  }
};
</script>

<style lang="scss" scoped>
.body {
  height: calc(100vh - 90px);
  // 去除卡片的padding
  ::v-deep .el-card__body {
    padding: 0px !important;
    height: 100%;
  }
  .box_card {
    height: 99%;
    margin-right: 30px;
    box-sizing: border-box;
    border-radius: 30px;
    .card-content {
      height: 100%;
      box-sizing: border-box;

      .header {
        background: #f0feff;
        border-radius: 30px 30px 0px 0px;
        padding: 12px 0 12px 31px;

        .header-l {
          cursor: pointer;
          color: #2d99d7;
          font-size: 20px;
          i {
            font-size: 30px;
            margin-right: 11px;
          }
        }
      }

      .main-content {
        padding: 0 30px;

        .titles {
          font-size: 22px;
          color: #2d99d7;
          margin: 14px 0 10px 0;
        }

        .descs {
          font-size: 16px;
          color: #666;
        }

        .main-table {
          margin-top: 10px;
          height: 36px;
          border-radius: 16px 16px 0px 0px;
          background: #31bfc5;
          font-size: 16px;
          font-weight: bold;
          color: #f8f9fe;
          padding-left: 25px;

          .item1 {
            width: 23%;
          }

          .item2 {
            width: 55%;
          }

          .item3 {
            width: 20%;
            text-align: center;
          }
        }
      }

      .meal-box {
        font-weight: bold;
        margin-top: 10px;
        .title {
          font-size: 18px;
          color: #333333;
          display: inline-block;
          margin-right: 19px;
        }

        .price {
          color: #f04562;
          font-size: 24px;
        }
      }

      .openBtn {
        margin-top: 10px;
      }

      .patient_box {
        height: calc(100vh - 400px);
        max-height: calc(100vh - 400px);
        border: 1px solid #ddd;
        overflow-y: auto;
        box-sizing: border-box;
        border-bottom-left-radius: 16px;
        border-bottom-right-radius: 16px;

        .patient_box_item {
          padding-left: 25px;
          background: #f8f9fe;
          padding: 10px 0;
          border-bottom: 1px solid #dddddd;

          .item1_content {
            width: 23%;
            font-size: 14px;
            font-weight: bold;
            color: #333333;
            padding-left: 10px;
          }

          .item2_content {
            width: 56%;
            font-size: 14px;
            font-weight: 400;
            color: #666666;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }

          .item3_content {
            width: 20%;
            height: 14px;
            font-size: 16px;
            font-weight: bold;
            color: #f04562;
            text-align: center;
          }
        }
      }
    }
    .bottom_pagination {
      width: 100%;
      height: 40px;
      // border: 1px solid red;
      display: flex;
      justify-content: center;
      justify-items: center;
      align-items: center;
      overflow: hidden;
    }
  }
  .itmeBox :hover {
    box-shadow: 0px 0px 10px #effffc;
    // background-color: red;
  }
}
</style>
